import { render, staticRenderFns } from "./ring-group-bulk-manage-modal.vue?vue&type=template&id=85354a06"
import script from "./ring-group-bulk-manage-modal.vue?vue&type=script&lang=js"
export * from "./ring-group-bulk-manage-modal.vue?vue&type=script&lang=js"
import style0 from "./ring-group-bulk-manage-modal.vue?vue&type=style&index=0&id=85354a06&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports